import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./DealTimer.css";

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
} 

const SodexoPaymentFunction: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

;


  const formatTime = (value: number): string => {
    return value.toString().padStart(2, "0");
  };

  return (
    <div className="mainDeal">
      <div className="dealTimer">
        <div className="dealTimerMainContent">
          <div className="dealTimeContent">
            <div className="dealTimeLink">
              {/* You can place a <Link> or CTA here */}
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default SodexoPaymentFunction;
